<script>
  import LandingPage from 'xca-app-core/src/views/LandingPage';

  export default {
    name: 'LandingPage',

    extends: LandingPage,

    data() {
      return {
        screenshots: [
          {src: '/img/screenshots/01.png'}
        ]
      };
    }
  };
</script>

<style lang="scss" scoped>
  @import '~xca-app-core/src/assets/scss/landingpage.scss';

  [id=page-landingPage],
  .v-btn.v-btn--outlined {
    color: #fff;
  }

  #page-landingPage h1 {
    text-transform: none !important;
  }

  .logo {
    width: 80px !important;
    background-color: #fff;
    border-radius: 10px;
  }

  #lp-content {
    background-image: url('/img/background.png');

    .screen-wrapper > img {
      filter: brightness(0.3);
    }
  }
</style>

<style>
  /* Does not work in scoped context. */
  #page-landingPage .logo .v-image__image--cover {
    background-size: 55px;
    border-radius: 5px;
  }
</style>
